import React, { Component, useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import BevetelezesLista from './components/Bevetelezes/BevetelezesLista.js';
import SelejtezesLista from './components/Selejtezes/SelejtezesLista.js';
import KeszletcsokkenesLista from './components/Keszletcsokkenes/KeszletcsokkenesLista.js';
import ForgalomLista from './components/Forgalom/ForgalomLista';
import LeltarLista from './components/Leltar/LeltarLista';
import { useNavigate } from 'react-router';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip.js';
import getTooltip from '../KeszletTooltips.js';

export default function WithNav(props) {
  return <Keszletkezeles {...props} navigate={useNavigate()} />
}

const Keszletkezeles = (props) => {
  const { globals } = props;

  const [activeTab, setActiveTab] = useState('1');

  const page = globals.useQuery().get("page");

  const defaultRoles = [
    {
      rolename: 'KESZLETNYILV_BEVETELEZES',
      tab: '1',
      spec: false
    },
    {
      rolename: 'KESZLETNYILV_CSOKKENES',
      tab: '2',
      spec: false
    },
    {
      rolename: 'KESZLETNYILV_SELEJTEZES',
      tab: '3',
      spec: false
    },
    // {
    //   rolename: 'ATADAS',
    //   tab: '4',
    //   spec: false
    // },
    {
      rolename: 'KESZLETNYILV_FORGALOM',
      tab: '5',
      spec: false
    },
    {
      rolename: 'KESZLETNYILV_LELTAR',
      tab: '6',
      spec: false
    }
  ];

  /** Lefut, amikor a komponens betöltődik. */
  useEffect(() => {
    if (page)
      toggle(page);
    else
      globals.setDefaultActiveTab(defaultRoles, toggle);
  }, []);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  }

  let cardStyle = {
    padding: 10
  };

  return (
    <div>
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            Készletnyilvántartás
            <CustomTooltip text={getTooltip('keszlet')} id="keszletTT" />
          </div>
          <div className="row" style={cardStyle}>
            <div className="col-md-12">
              <Nav tabs>
                {
                  globals.hasRole(['KESZLETNYILV_BEVETELEZES']) && (
                  <NavItem>
                    <NavLink href="#" className={classnames({ active: activeTab === '1' })} onClick={() => { toggle('1'); }}>
                      Készletnövekedés
                    </NavLink>
                  </NavItem>
                  )
                }
                {
                  globals.hasRole(['KESZLETNYILV_CSOKKENES']) && (
                  <NavItem>
                    <NavLink href="#" className={classnames({ active: activeTab === '2' })} onClick={() => { toggle('2'); }}>
                      Készletcsökkenés
                    </NavLink>
                  </NavItem>
                  )
                }
                {
                  globals.hasRole(['KESZLETNYILV_SELEJTEZES']) && (
                  <NavItem>
                    <NavLink href="#" className={classnames({ active: activeTab === '3' })} onClick={() => { toggle('3'); }}>
                      Selejtezés
                    </NavLink>
                  </NavItem>
                  )
                }
                {/* 
                {globals.hasRole(['ATADAS']) &&
                  <NavItem>
                    <NavLink href="#" className={classnames({ active: activeTab === '4' })} onClick={() => { toggle('4'); }}>
                      Raktárközi átadás
                    </NavLink>
                  </NavItem>
                } 
                */}
                {
                  globals.hasRole(['KESZLETNYILV_FORGALOM']) && (
                  <NavItem>
                    <NavLink href="#" className={classnames({ active: activeTab === '5' })} onClick={() => { toggle('5'); }}>
                      Forgalom
                    </NavLink>
                  </NavItem>
                  )
                }
                {
                  globals.hasRole(['KESZLETNYILV_LELTAR']) && (
                  <NavItem>
                    <NavLink href="#" className={classnames({ active: activeTab === '6' })} onClick={() => { toggle('6'); }}>
                      Leltár
                    </NavLink>
                  </NavItem>
                  )
                }
              </Nav>
              <TabContent activeTab={activeTab}>
                {globals.hasRole(['KESZLETNYILV_BEVETELEZES']) && (
                  <TabPane tabId="1">
                    <BevetelezesLista {...props} globals={globals} />
                  </TabPane>
                )}
                {globals.hasRole(['KESZLETNYILV_CSOKKENES']) && (
                  <TabPane tabId="2">
                    <KeszletcsokkenesLista {...props} globals={globals} />
                  </TabPane>
                )}
                {globals.hasRole(['KESZLETNYILV_SELEJTEZES']) && (
                  <TabPane tabId="3">
                    <SelejtezesLista {...props} globals={globals} /> 
                  </TabPane>
                )}
                {globals.hasRole(['KESZLETNYILV_FORGALOM']) && (
                  <TabPane tabId="5">
                    <ForgalomLista {...props} globals={globals} />
                  </TabPane>
                )}
                {globals.hasRole(['KESZLETNYILV_LELTAR']) && (
                  <TabPane tabId="6">
                    <LeltarLista {...props} globals={globals} />
                  </TabPane>
                )}
              </TabContent>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
